import { Theme } from '@pga/pga-component-library'
import styled from 'styled-components'
import MapPinSvgIcon from '../../../../assets/icons/map-pin.svg'

export const LocationDropDown = styled.div.attrs({
  className: 'form-inline'
})`
  font-family: ${Theme.fonts.Montserrat};
  justify-content: flex-start;
  > .form-control:focus {
    box-shadow: none;
    background-color: transparent;
  }

  #location-proximity-miles, label {
    font-family: ${Theme.fonts.Montserrat};
    height: 24px;
    color: ${Theme.colors.primary};
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
    padding: 0 0 0 5px;
  }
`

export const Label = styled.label`
  display: flex;
  justify-content: flex-start;
`

export const MileSelect = styled.select`
  background-color: transparent;
  border: 0;
`

export const MapMarker = styled.img.attrs({
  src: MapPinSvgIcon
})`
  margin-right: 10px;
  width: 14px;
`
